module.exports = __webpack_public_path__ + "img/num02.5f106912.png";